<div *ngIf="data$ | async as data">
  <ng-container *ngIf="routerLink">
    <a
      [routerLink]="routerLink | cxUrl"
      [queryParams]="setRouterQueryParams(data)"
      (click)="handleBannerClick(data)"
      [attr.title]="!data.headline ? getImageAltText(data) : null">
      <p class="headline" *ngIf="data.headline" [innerHTML]="data.headline"></p>
      <cx-media
        [container]="getImage(data)"
      ></cx-media>
      <p class="content" *ngIf="data.content" [innerHTML]="data.content"></p>
    </a>
  </ng-container>

  <ng-container *ngIf="!routerLink">
    <div class="no-link">
      <p class="headline" *ngIf="data.headline" [innerHTML]="data.headline"></p>
      <cx-media
        [container]="getImage(data)"
      ></cx-media>
      <p class="content" *ngIf="data.content" [innerHTML]="data.content"></p>
    </div>
  </ng-container>
</div>
